import React, { useCallback, useState } from 'react';
import { Popconfirm } from 'antd';
import { DDQr, WXQr } from './config'

const btnProps = {
  style: {
    display: 'none'
  }
}

const CustomerDrop = React.memo(() => {
  return <div className="customer-drop-block">
    <div className="head">
      <div className="title">联系方式</div>
      <div className="text">您可以通过以下方式找到我们</div>
    </div>
    <div className="email-block">
      <div className="label">邮箱</div>
      <div className="value can-user-select">kuyang.xingyuan@service.alibaba.com</div>
    </div>
    <div className="qr-block">
      <div className="qr-item">
        <div className="title">钉钉客服</div>
        <div className="qr">
          <img className="img" src={DDQr} />
        </div>
      </div>
      <div className="qr-item">
        <div className="title">微信公众号</div>
        <div className="qr">
          <img className="img" src={WXQr} />
        </div>
      </div>
    </div>
  </div>
});

const Consult = (props) => {
  // const { isLogin, authMap = {}, userType } = props

  const [visible, setVisible] = useState<boolean>(false);
  const [btnClass, setBtnClass] = useState<string>('');
  const onVisibleChange = useCallback((visible) => {
    if (visible) {
      setBtnClass('selected')
    } else {
      setBtnClass('')
    }
    setVisible(visible)
  }, [])
  const getPopupContainer = useCallback((triggerNode) => {
    return triggerNode
  }, [])

  return <div className="star-consult-tool">
    <div className="customer-block">
      <Popconfirm
        overlayClassName="customer-drop"
        placement="leftBottom"
        trigger="hover"
        icon={null}
        title={<CustomerDrop />}
        cancelButtonProps={btnProps}
        okButtonProps={btnProps}
        visible={visible}
        onVisibleChange={onVisibleChange}
        getPopupContainer={getPopupContainer}
      >
        <div className={`connect ${btnClass || ''}`}>
          <img className="img d-img" src="//img.alicdn.com/imgextra/i4/O1CN01Nx0kOQ21WO4Il0x9v_!!6000000006992-2-tps-72-72.png" />
          <img className="img s-img" src="//img.alicdn.com/imgextra/i4/O1CN01WqpLUL1plhvjUvCsb_!!6000000005401-2-tps-72-72.png" />
        </div>
      </Popconfirm>
    </div>
    <a className="call-me" href="/star-source/consult">咨询我们</a>
  </div>
};

export default React.memo(Consult)
